import { some, isEqual, omit } from 'lodash';

const propsHasChanged = (nextProps, prevProps, omitKeys = []) =>
  some(
    Object.keys(omit(nextProps, omitKeys)).concat(
      Object.keys(omit(prevProps, omitKeys))
    ),
    propName => !isEqual(nextProps[propName], prevProps[propName])
  );

export function propHasChangedWithFilter(
  nextProps,
  previousProps,
  filterKeys = []
) {
  if (filterKeys.length === 0) {
    throw new Error('This function requires at least one key to filter on');
  }
  return !!filterKeys.find(key => nextProps[key] !== previousProps[key]);
}

export default propsHasChanged;
export const propsHasChangedMemo = propsHasChanged;
